

import { createSlice, PayloadAction } from "@reduxjs/toolkit";

interface DashBoardState {
  dashboard: {
    dashboardData: any[];
    dashboardSpData: any[];
    dashboardCriticalData: any[];
    dashboardSOPOData: any[];
    dashboardCashAndBankData: any[];
    dashboardAmountPayData: any[];
    dashboardAmountRecData: any[];
    dashboardExpenseCardData: any[];
    dashboardAmountRecDebitorData: any[];
    dashboardAmountRecCreditorData: any[];
    dashboardAmountPayDebitorData: any[];
    dashboardAmountPayCreditorData: any[];
     salesAccountWiseData: any[];
    purchaseAccountWiseData: any[];
  };
  loading: boolean;
  error: string | null;
  refreshTrigger: number;
}

const initialState: DashBoardState = {
  dashboard: {
    dashboardData: [],
    dashboardSpData: [],
    dashboardCriticalData: [],
    dashboardSOPOData: [],
    dashboardCashAndBankData: [],
    dashboardAmountPayData: [],
    dashboardAmountRecData: [],
    dashboardExpenseCardData: [],

    dashboardAmountRecDebitorData: [],
    dashboardAmountRecCreditorData: [],
    dashboardAmountPayDebitorData: [],
    dashboardAmountPayCreditorData: [],
    salesAccountWiseData: [],     
    purchaseAccountWiseData: [],
  },
  loading: false,
  error: null,
  refreshTrigger: 0,
};

const dashboardSlice = createSlice({
  name: "dashboard",
  initialState,
  reducers: {
    setDashboardData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardData = action.payload;
      state.error = null;
    },
    setDashboardSpData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardSpData = action.payload;
      state.error = null;
    },
    setDashboardCriticalData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardCriticalData = action.payload;
      state.error = null;
    },
    setDashboardSOPOData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardSOPOData = action.payload;
      state.error = null;
    },
    setDashboardCashAndBankData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardCashAndBankData = action.payload;
      state.error = null;
    },
    setDashboardAmountPayData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardAmountPayData = action.payload;
      state.error = null;
    },
    setDashboardAmountRecData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardAmountRecData = action.payload;
      state.error = null;
    },
    setDashExpenseCardData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardExpenseCardData = action.payload;
      state.error = null;
    },
    setLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
    setError(state, action: PayloadAction<string>) {
      state.error = action.payload;
    },
    //THESE 4 reducers:
    setDashboardAmountRecDebitorData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardAmountRecDebitorData = action.payload;
      state.error = null;
    },
    setDashboardAmountRecCreditorData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardAmountRecCreditorData = action.payload;
      state.error = null;
    },
    setDashboardAmountPayDebitorData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardAmountPayDebitorData = action.payload;
      state.error = null;
    },
    setDashboardAmountPayCreditorData(state, action: PayloadAction<any[]>) {
      state.dashboard.dashboardAmountPayCreditorData = action.payload;
      state.error = null;
    },
//-----for  account wise  sale  and  purchase------------------
  setSalesAccountWiseData(state, action: PayloadAction<any[]>) {
  state.dashboard.salesAccountWiseData = action.payload;
  state.error = null;
},
setPurchaseAccountWiseData(state, action: PayloadAction<any[]>) {
  state.dashboard.purchaseAccountWiseData = action.payload;
  state.error = null;
},
    triggerRefresh(state) {
      state.refreshTrigger += 1;
    },
  },
});

export const {
  setDashboardData,
  setDashboardSpData,
  setDashboardCriticalData,
  setDashboardSOPOData,
  setDashboardCashAndBankData,
  setDashboardAmountPayData,
  setDashboardAmountRecData,
  setDashExpenseCardData,
  setLoading,
  setError,
  
  setDashboardAmountRecDebitorData,
  setDashboardAmountRecCreditorData,
  setDashboardAmountPayDebitorData,
  setDashboardAmountPayCreditorData,

    setSalesAccountWiseData,
  setPurchaseAccountWiseData,
  triggerRefresh,
} = dashboardSlice.actions;
export default dashboardSlice.reducer;
